import React from 'react'
import './Faq.css'
import FaqItems from './FaqItems';

function Faq() {

  return (
    <div>
        <div className="faq-section" id='Faq'>
            <div className="container">
                <div className="faq-content">
                <div className="faq-header">
                    <div className="tagline">
                        <span>FREQUENTLY ASKED QUESTIONS</span>
                    </div>
                        <h2>Some questions about our Services</h2>
                        <p className='text'>Have questions? Our FAQ covers key topics like Cash in Transit, security services, and more. We're here to help!</p>
                    </div>

                    <div className="faqs">
                     <FaqItems />
                    </div>

                </div>
            </div>
        </div>
    </div>
  )
}

export default Faq
